import React from 'react';
import {
  VertModal,
  VertContainer,
  Row,
  Col,
  VertButton,
  Typography,
  notification,
} from '@vertem-core/vertice-ds';
import { useSelector } from 'react-redux';
import { useSimulationLocalStorageContext } from 'Context/SimulationLocalSotrageContext';
import { cloudloyalty } from 'Services/Apis/clients';
import { useHierarchyProductsLocalStorageContext } from 'Context/HierarchyLocalStorageContext';

const FinishSimulationModal = ({ isOpen, onClose }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const accessToken = useSelector((state) => state.oidc.user.access_token);

  const { simulationLocalStorageValue, setSimulationLocalStorageValue } =
    useSimulationLocalStorageContext();
  const { setHierarchyLocalStorageValue } =
    useHierarchyProductsLocalStorageContext();

  const findNameOfParticipantSelectedForHierarchy = ({ maxNameSize }) => {
    const participantName = simulationLocalStorageValue?.name;

    if (participantName?.length > maxNameSize) {
      return participantName.substring(0, maxNameSize) + '...';
    } else {
      return participantName;
    }
  };

  const finishSimulation = async () => {
    setIsLoading(true);
    try {
      await cloudloyalty({
        access_token: `Bearer ${accessToken}`,
      }).delete(`v1/participants/impersonate`);

      setSimulationLocalStorageValue({});
      setHierarchyLocalStorageValue({ products: [] });
      setIsLoading(false);
      notification.success({
        message: 'Você não está mais impersonando o participante',
      });
      onClose();
    } catch (error) {
      notification.error({
        message: 'Erro ao deixar de impersonar participante',
        description: 'Tente novamente.',
      });
      setIsLoading(false);
    }
  };

  return (
    <VertModal
      destroyOnClose={false}
      open={isOpen}
      onCancel={onClose}
      footer={
        <VertContainer className="col-12">
          <Row gutter={[16, 16]}>
            <Col lg={12} md={12} sm={24} xs={24}>
              <VertButton className="col-12" type="default" onClick={onClose}>
                CANCELAR
              </VertButton>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
              <VertButton
                loading={isLoading}
                color="var(--color-danger)"
                className="col-12"
                type="default"
                onClick={finishSimulation}
              >
                ENCERRAR
              </VertButton>
            </Col>
          </Row>
        </VertContainer>
      }
    >
      <VertContainer>
        <Typography.Title level={2} style={{ color: 'var(--color-detached)' }}>
          {`Deseja encerrar simulação?`}
        </Typography.Title>
        <Typography.Text style={{ color: 'var(--color-detached)' }}>
          {'Ao clicar em'}
        </Typography.Text>
        <Typography.Text strong style={{ color: 'var(--color-detached)' }}>
          {' ENCERRAR'}
        </Typography.Text>
        <Typography.Text style={{ color: 'var(--color-detached)' }}>
          {' você encerrará a simulação pelo participante '}
        </Typography.Text>
        <Typography.Text
          strong
          style={{ color: 'var(--color-detached)', fontSize: '1.2rem' }}
        >
          {`${findNameOfParticipantSelectedForHierarchy({ maxNameSize: 40 })}`}
        </Typography.Text>
        <Typography.Text style={{ color: 'var(--color-detached)' }}>
          {' e a lista de produtos adicionados a solicitação, será '}
        </Typography.Text>
        <Typography.Text strong style={{ color: 'var(--color-detached)' }}>
          {'esvaziada.'}
        </Typography.Text>
      </VertContainer>
    </VertModal>
  );
};

export default FinishSimulationModal;
